import React, { useEffect, useState, useRef } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import DashboardFooter from "./DashboardFooter";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Bonafide.css";
import { FaPrint } from "react-icons/fa";

const API_URL = "https://auxititpt.org/Backend/bonafide_api.php";
const LETTERHEAD_IMAGE =
  "https://auxititpt.org/public/uploads/Letter_Head_Axilium_English.jpg";

const BonafideCertificate = () => {
  const [students, setStudents] = useState([]);
  const [trades, setTrades] = useState([]);
  const [batches, setBatches] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);

  const [selectedTrade, setSelectedTrade] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [student, setStudent] = useState(null);
  const [certificateDate, setCertificateDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const printRef = useRef();

  // Load all students initially
  useEffect(() => {
    fetchStudents();
  }, []);

  /** 🔹 Fetch all students from backend */
  const fetchStudents = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      if (Array.isArray(data)) {
        setStudents(data);

        // Unique trades
        const uniqueTrades = [...new Set(data.map((s) => s.trade))].sort();
        setTrades(uniqueTrades);
      } else {
        setStudents([]);
        setTrades([]);
      }
    } catch (err) {
      console.error("Error fetching students:", err);
    }
  };

  /** 🔹 Handle trade selection */
  const handleTradeChange = (e) => {
    const trade = e.target.value;
    setSelectedTrade(trade);
    setSelectedBatch("");
    setSelectedId("");
    setStudent(null);

    if (trade) {
      const tradeStudents = students.filter((s) => s.trade === trade);
      const uniqueBatches = [...new Set(tradeStudents.map((s) => s.course_start))].sort();
      setBatches(uniqueBatches);
    } else {
      setBatches([]);
      setFilteredStudents([]);
    }
  };

  /** 🔹 Handle batch selection */
  const handleBatchChange = (e) => {
    const batch = e.target.value;
    setSelectedBatch(batch);
    setSelectedId("");
    setStudent(null);

    if (batch) {
      const filtered = students.filter(
        (s) => s.trade === selectedTrade && s.course_start === batch
      );
      setFilteredStudents(filtered);
    } else {
      setFilteredStudents([]);
    }
  };

  /** 🔹 Handle student selection */
  const handleSelectStudent = async (id) => {
    setSelectedId(id);
    if (!id) {
      setStudent(null);
      return;
    }

    try {
      const res = await fetch(`${API_URL}?id=${id}`);
      const data = await res.json();
      setStudent(data);
    } catch (err) {
      console.error("Error fetching student details:", err);
      setStudent(null);
    }
  };
  /** Print Bonafide Certificate – Popup Window (Keeps Your Exact HTML & Styles) */
  const handlePrint = () => {
    if (!printRef.current || !student) return;

    const printContents = printRef.current.innerHTML;
    const todayFormatted = new Date(certificateDate).toLocaleDateString("en-GB");

    const popup = window.open("", "_blank", "width=900,height=1000,scrollbars=no,resizable=yes");

    popup.document.write(`
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Bonafide Certificate - ${student.name}</title>
  <style>
    @page { size: A4; margin: 0; }
    html, body { margin:0; padding:0; height:297mm; overflow:hidden; }
    body {
      font-family: 'Poppins', sans-serif;
      position: relative;
    }

    /* Force Letterhead Background */
    body::before {
      content: '';
      position: fixed;
      top: 0; left: 0;
      width: 210mm; height: 297mm;
      background: url('${LETTERHEAD_IMAGE}') no-repeat top center / 100% auto;
      z-index: -1;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    .certificate {
      padding: 80mm 20mm 20mm 20mm;
      position: relative;
      z-index: 1;
      font-size: 1.1rem;
      color: #222;
      line-height: 1.6;
    }

    .date {
      text-align: right;
      margin-bottom: 20px;
      font-weight: 500;
      font-size: 1.1rem;
    }

    h2 {
      text-align: center;
      color: #012a5a;
      text-decoration: underline;
      margin-bottom: 30px;
      font-size: 1.8rem;
    }

    .to-whom {
      text-align: center;
      margin-bottom: 20px;
    }

    .signature {
      margin-top: 50px;
      text-align: right;
      font-weight: bold;
      font-size: 1.2rem;
      padding-top: 60px;
    }

    @media print {
      body::before {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
    }
  </style>
</head>
<body>
  <div class="certificate">
    <div class="date">
      <strong>Date:</strong> ${todayFormatted}
    </div>

    <h2>Bonafide Certificate</h2>

    <div class="content">
      <p class="to-whom">To Whom It May Concern,</p>

      <p>
        This is to certify that <strong>${student.name}</strong>, S/o or D/o
        <strong>${student.father_name}</strong>, is a trainee of our institute.
        He/She is studying <strong>${student.trade}</strong> trade in our
        Institute. The duration of the course is
        <strong>${student.duration}</strong> year(s), valid from
        <strong>${student.course_start}</strong> to
        <strong>${student.course_end}</strong>.
      </p>

      <p>
        To the best of my knowledge and belief, he/she bears good conduct and
        character.
      </p>

      <div class="signature mt-5">
        <p>Principal Signature</p>
      </div>
    </div>
  </div>

  <script>
    window.onload = () => setTimeout(() => window.print(), 400);
    window.onafterprint = () => window.close();
    const mq = window.matchMedia('print');
    mq.addEventListener('change', (m) => {
      if (!m.matches) setTimeout(() => window.close(), 100);
    });
  </script>
</body>
</html>
    `);

    popup.document.close();
    popup.focus();
  };

  const todayFormatted = new Date(certificateDate).toLocaleDateString("en-GB");

  return (
    <div className="bonafide-page">
      <div className="d-flex dashboard-container">
        <Sidebar />
        <div className="main-content flex-grow-1">
          <Header />

          <div className="container py-5">
            <h3 className="fw-bold mb-4 text-primary">Bonafide Certificate</h3>

            {/* Trade, Batch, Student Selection */}
            <div className="card p-4 shadow-sm mb-4">
              <div className="row g-3">
                {/* 🔹 Trade */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Select Trade</label>
                  <select
                    className="form-select"
                    value={selectedTrade}
                    onChange={handleTradeChange}
                  >
                    <option value="">-- Select Trade --</option>
                    {trades.map((trade, index) => (
                      <option key={index} value={trade}>
                        {trade}
                      </option>
                    ))}
                  </select>
                </div>

                {/* 🔹 Batch */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Select Batch (Year)</label>
                  <select
                    className="form-select"
                    value={selectedBatch}
                    onChange={handleBatchChange}
                    disabled={!selectedTrade}
                  >
                    <option value="">-- Select Batch --</option>
                    {batches.map((batch, index) => (
                      <option key={index} value={batch}>
                        {batch}
                      </option>
                    ))}
                  </select>
                </div>

                {/* 🔹 Student */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Select Student</label>
                  <select
                    className="form-select"
                    value={selectedId}
                    onChange={(e) => handleSelectStudent(e.target.value)}
                    disabled={!selectedBatch}
                  >
                    <option value="">-- Select Student --</option>
                    {filteredStudents.map((s) => (
                      <option key={s.student_id} value={s.student_id}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Certificate Date */}
              <div className="row mt-4">
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Certificate Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={certificateDate}
                    onChange={(e) => setCertificateDate(e.target.value)}
                  />
                </div>
              </div>

              {/* Auto-Filled Info */}
              {student && (
                <div className="row mt-4">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Student Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={student.name}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Trade</label>
                    <input
                      type="text"
                      className="form-control"
                      value={student.trade}
                      readOnly
                    />
                  </div>
                </div>
              )}
            </div>

            {/* Certificate Preview */}
            {student && (
              <>
                <div ref={printRef} className="certificate shadow-lg p-5 bg-white mb-4">
                  <div className="date">
                    <strong>Date:</strong> {todayFormatted}
                  </div>

                  <h2>Bonafide Certificate</h2>

                  <div className="content">
                    <p className="to-whom">To Whom It May Concern,</p>

                    <p>
                      This is to certify that <strong>{student.name}</strong>, S/o or D/o{" "}
                      <strong>{student.father_name}</strong>, is a trainee of our institute.
                      He/She is studying <strong>{student.trade}</strong> trade in our
                      Institute. The duration of the course is{" "}
                      <strong>{student.duration}</strong> year(s), valid from{" "}
                      <strong>{student.course_start}</strong> to{" "}
                      <strong>{student.course_end}</strong>.
                    </p>

                    <p>
                      To the best of my knowledge and belief, he/she bears good conduct and
                      character.
                    </p>

                    <div className="signature mt-5">
                      <p>Principal Signature</p>
                    </div>
                  </div>
                </div>

                {/* Print Button */}
                <div className="text-center mt-4 mb-4">
                  <button className="btn btn-success px-4" onClick={handlePrint}>
                    <FaPrint className="me-2" />
                    Print Certificate
                  </button>
                </div>
              </>
            )}
          </div>

          <DashboardFooter />
        </div>
      </div>
    </div>
  );
};

export default BonafideCertificate;
